import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function useNavigateLang() {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  return path => navigate(`/${i18n.language}${path}`);
}
